import { rpcEffectCaller } from "@crm/rpc-client";
import { StudentTasksRpc } from "@crm/rpc-contract/groups/student-tasks";
import { queryAtomEffect } from "@crm/shared/query-atom/effect";
import { Effect } from "effect";

// 类型化 RPC Effect 调用器（错误通道保留）
const studentTasks = rpcEffectCaller(StudentTasksRpc);

/**
 * 学员任务上下文查询域（对应 studentTaskKeys.context，Effect-native）。
 *
 * 首页（routes/_protected/index.tsx）与任务页（routes/_protected/student-tasks/index.tsx）
 * 共用同一原子：key = studentId（缓存身份），任一 reactivityKeys 失效或
 * useAtomRefresh 都驱动两个页面同步刷新。
 *
 * 轮询说明：queryAtomEffect 无 refetchInterval 轮询参数，任务页用
 * `setInterval + useAtomRefresh` 实现等效 30s 轮询（见该页注释）。
 */
export const studentTaskContextAtom = queryAtomEffect(
  (_key: readonly [string]) =>
    studentTasks.getStudentTaskContext(undefined).pipe(
      Effect.map((response) => (response.success ? response.data : null)),
    ),
  { staleTime: 30_000, reactivityKeys: ["studentTaskContext"] },
);
